import { StoryLine, Character  } from "./type";
import * as StorylineFactory from "../../../alg/istoryline";

export class LayoutGenerator {
  storylines: StoryLine[];
  characters: Character[];
  charactersRiskNum: number[];
  riskGroupsList: number[][];
  constructor(storyScript, x0, y0, width, height) {
    const iStoryliner = new StorylineFactory.iStoryline();
    const graph = iStoryliner.generateLayout(
      storyScript,
      x0,
      y0,
      width,
      height
    );
    const {
      riskGroupLines: riskGroupsList,
      charactersRiskNum,
    } = this.computeRiskGroupIndex(storyScript);
    const storylines = this.postProcessYScale(
      riskGroupsList,
      graph.storylines,
      height
    );
    this.storylines = storylines;
    this.characters = graph.characters;
    this.charactersRiskNum = charactersRiskNum;
    this.riskGroupsList = riskGroupsList;
  }

  postProcessYScale(
    riskGroupsListInput: number[][],
    storylinesInput: number[][][][],
    containerH: number
  ) {
    const riskGroupsList = JSON.parse(JSON.stringify(riskGroupsListInput));
    const storylinesOrigin = JSON.parse(JSON.stringify(storylinesInput));
    const storylines = [];
    const connectLineRatio = 0.1;
    // retain 4 points for one segment
    for (let i = 0; i < storylinesOrigin.length; i++) {
      storylines.push([]);
      for (let j = 0; j < storylinesOrigin[i].length; j++) {
        storylines[i].push([]);
        const pointsNum = storylinesOrigin[i][j].length;
        const startX = storylinesOrigin[i][j][0][0];
        const endX = storylinesOrigin[i][j][pointsNum - 1][0];
        const medianY = storylinesOrigin[i][j][Math.floor(pointsNum / 2)][1];
        const connectWidth = connectLineRatio * (endX - startX);
        storylines[i][j].push([startX, medianY]);
        storylines[i][j].push([startX + connectWidth, medianY]);
        storylines[i][j].push([endX - connectWidth, medianY]);
        storylines[i][j].push([endX, medianY]);
      }
    }
    // sort by Y value - small to big
    for (let i = 0; i < riskGroupsList.length; i++) {
      for (let j = 0; j < riskGroupsList[i].length - 1; j++) {
        for (let k = j + 1; k < riskGroupsList[i].length; k++) {
          const yJ = storylines[riskGroupsList[i][j]][i][0][1];
          const yK = storylines[riskGroupsList[i][k]][i][0][1];
          if (yJ > yK) {
            const t = riskGroupsList[i][j];
            riskGroupsList[i][j] = riskGroupsList[i][k];
            riskGroupsList[i][k] = t;
          }
        }
      }
    }
    const lineCount = storylines.length;
    const scaleRatio = 0.2;
    const linesGap = (scaleRatio * containerH) / (lineCount + 1);
    for (let i = 0; i < riskGroupsList.length; i++) {
      const riskGroupGap = linesGap * (riskGroupsList[i].length - 1);
      let linesYSum = 0;
      for (let j = 0; j < riskGroupsList[i].length; j++) {
        linesYSum += storylines[riskGroupsList[i][j]][i][0][1];
      }
      const riskGroupYStart =
        linesYSum / riskGroupsList[i].length - riskGroupGap / 2;
      for (let j = 0; j < riskGroupsList[i].length; j++) {
        for (let k = 0; k < storylines[riskGroupsList[i][j]][i].length; k++) {
          storylines[riskGroupsList[i][j]][i][k][1] =
            riskGroupYStart + j * linesGap;
        }
      }
    }
    return storylines;
  }

  computeRiskGroupIndex(audioScript: any) {
    const charactersData = audioScript.Story.Characters;
    const characters = Object.keys(charactersData);
    const sessionCount = charactersData[characters[0]].length;
    const lineCount = characters.length;
    const charactersRiskNum = new Array(lineCount).fill(0);
    const riskGroupLines: number[][] = [];
    for (let i = 0; i < sessionCount; i++) {
      const riskGroupLinesIndex: number[] = [];
      let riskGroupSession = 0;
      let isFindGroup = false;
      for (let j = 0; j < lineCount; j++) {
        const characterSession = charactersData[characters[j]][i].Session;
        if (isFindGroup) {
          if (characterSession === riskGroupSession) {
            riskGroupLinesIndex.push(j);
            charactersRiskNum[j]++;
          }
        } else {
          for (let k = 0; k < j; k++) {
            if (characterSession === charactersData[characters[k]][i].Session) {
              riskGroupSession = characterSession;
              isFindGroup = true;
              riskGroupLinesIndex.push(k);
              riskGroupLinesIndex.push(j);
              charactersRiskNum[k]++;
              charactersRiskNum[j]++;
              break;
            }
          }
        }
      }
      riskGroupLines.push(riskGroupLinesIndex);
    }
    return {
      riskGroupLines: riskGroupLines,
      charactersRiskNum: charactersRiskNum,
    };
  }
}
